const DEFAULT_PORTAL_BASE_URL = "https://portal.claritygroup.com.sg";

function normalizeBaseUrl(value: string | null | undefined): string | null {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return null;
  try {
    return new URL(trimmed).origin.replace(/\/+$/, "");
  } catch {
    return null;
  }
}

export function getPortalBaseUrl(): string {
  if (typeof window !== "undefined") {
    const fromWindow = normalizeBaseUrl(window.location?.origin);
    if (fromWindow) return fromWindow;
  }
  return DEFAULT_PORTAL_BASE_URL;
}

export function buildSvrTrackingUrl(token: string): string {
  return `${getPortalBaseUrl()}/track/svr/${encodeURIComponent(token)}`;
}

